// extracted by mini-css-extract-plugin
export default {"productFeatured":"nga-z","carousel":"oga-z","slides":"pga-z","slide":"qga-z","slideFeatured":"rga-z","zoomMode":"sga-z","fadeIn":"tga-z","imageSizing":"uga-z"};